import React from "react";
import "./LookingAheadCard.css";

const LookingAheadCard = ({
  title,
  backgroundImage,
  mainImage,
  description = [],  // ✅ default to []
}) => {
  return (
    <div
      className="looking-ahead-card container mb-5"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >

      <div className="card-title">{title}</div>

      <div className="card-main-image">
        <img src={mainImage} alt={title} />
      </div>

      <div className="card-description">
        {description.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
      </div>

    </div>
  );
};


export default LookingAheadCard;
